
export { ShoppingBagButton } from "/codebuild/output/src1758541852/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"